/**
 * Resuming Workout Loader
 * A subtle toast-style loader shown during workout hydration
 */

import { cn } from '@/lib/utils'
import { LoaderIcon } from '@/components/ui/Icons'

interface ResumingWorkoutLoaderProps {
  isVisible: boolean
}

export function ResumingWorkoutLoader({ isVisible }: ResumingWorkoutLoaderProps) {
  return (
    <div
      className={cn(
        'fixed top-4 inset-x-4 z-50 flex justify-center pointer-events-none',
        'transition-all duration-300 ease-out',
        isVisible
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 -translate-y-4'
      )}
    >
      <div
        className={cn(
          'bg-surface/90 backdrop-blur-xl border border-white/10',
          'rounded-full px-5 py-2.5 shadow-elevated',
          'flex items-center gap-3'
        )}
      >
        <LoaderIcon className="w-4 h-4 text-primary animate-spin" />
        <span className="text-sm font-medium text-text-primary">
          Resuming workout...
        </span>
      </div>
    </div>
  )
}

export default ResumingWorkoutLoader
